export default "__VITE_ASSET__DEP9mNob__"